import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { confirmReturnedAlipayRedirect } from '../../lib/payment-methods';

export default function AlipayReturnCoordinator() {
  const navigate = useNavigate();
  const confirmationStartedRef = useRef(false);

  useEffect(() => {
    if (
      confirmationStartedRef.current
      || window.location.pathname === '/pay/alipay/return'
    ) return;
    confirmationStartedRef.current = true;
    let cancelled = false;
    void confirmReturnedAlipayRedirect().then((pending) => {
      if (cancelled || pending?.outcome?.kind !== 'succeeded') return;
      navigate(`/pay/alipay/return?${new URLSearchParams({
        payment_intent_id: pending.paymentIntentId,
        verified: '1',
      }).toString()}`, { replace: true });
    });
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return null;
}
